import disputeRepository from '@/domain/repository/DisputeRepository';
import {Dispute, toDomain, toDto} from '@/domain/entities/Dispute';

export const createDispute = async (dispute: Dispute): Promise<Dispute | undefined> => {
  try {
    if(!dispute) return undefined;

    const dto = toDto(dispute);

    const result = await disputeRepository.createDispute(dto);
    return result ? toDomain(result) : undefined;

  } catch (error) {
    console.error('Error creating dispute', error);
    return Promise.reject(dispute);
  }
};